import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { scrollToElement } from "../../../lib/userFunctions";
import { Loading } from "../../components/Loading";
import { UserProfileInline } from "app/components/UserProfileInline";
import {
  fetchUserFollowingList,
  userFollowing,
} from "../ducks/userFollowingList";

const UserFollowingList = () => {
  const dispatch = useDispatch();
  const { user } = useParams();
  const auth = useSelector((state) => state.auth);
  const userInfo = useSelector((state) => state.userInfo);
  const followList = useSelector((state) => state.userFollowingList);

  useEffect(() => {
    scrollToElement("lnb");
    dispatch(fetchUserFollowingList(user));
  }, [dispatch, user]);

  function onClickFollow(follow) {
    if (follow.response === "Y") return;
    const result = dispatch(userFollowing(follow.id));
    result
      .then((res) => {
        if (res.data.result) {
          dispatch(fetchUserFollowingList(user));
        } else {
          alert(res.data.message);
        }
      })
      .catch((res) => {
        alert("처리중 장애가 발생했습니다.");
        console.log("catch:", res);
      });
  }

  function renderList() {
    return followList.list.map((follow) => {
      return (
        <div key={follow.id} className="follow">
          <UserProfileInline
            name={follow.name}
            image={follow.image}
            userid={follow.userid}
            type={follow.type}
            school={follow.schoolName}
          />
          {user === auth.id && (
            <button
              className={`btn _xsm follow ${
                follow.response === "Y" ? "active" : ""
              }`}
              onClick={() => {
                onClickFollow(follow);
              }}
            >
              팔로잉
            </button>
          )}
        </div>
      );
    });
  }

  if (!userInfo.result) return null;
  if (followList.loading) return <Loading />;
  if (followList.list == null) return null;
  if (followList.list.length <= 0)
    return (
      <div className="no_data text-center">
        <p>팔로워가 없습니다.</p>
      </div>
    );

  return (
    <div className="inner">
      <div className="userFollowListContainer">
        <div className="countInfo text-right">
          <strong>{userInfo.user.name}</strong>님이{" "}
          <strong>{followList.list.length}</strong> 명의 친구를 팔로잉 하고
          있습니다.
        </div>
        <div className="followList">{renderList()}</div>
      </div>
    </div>
  );
};
export default UserFollowingList;
